/** api/courier 的 token 类型 */
export enum CourierSourceType {
  /** token 来自 h5的 /api/courier/token/visitor/getToken 接口 */
  H5 = 0,
  /** token 来自 小程序的 /api/courier/mini/getToken 接口 */
  Mini = 1,
}
